<template>
    <header>
        <div class="container pl-0 pr-0">
            <b-navbar toggleable="lg" type="light">
                <b-navbar-brand :href="appUrl">
                    <img :src="appUrl+'/guest/images/True-Wholesale.png'" alt="True Wholesale">
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item href="">Stationary</b-nav-item>
                        <b-nav-item href="">Paper Clip</b-nav-item>
                        <b-nav-item-dropdown text="Books">
                            <b-dropdown-item href="">Books</b-dropdown-item>
                            <b-dropdown-item href="">Paper Clip</b-dropdown-item>
                            <b-dropdown-item href="">Pencil</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item href="">Pencil</b-nav-item>
                        <b-nav-item href="">Contact</b-nav-item>
                        <div class="left-border mr-3"></div>
                        <b-nav-item :href="appUrl + '/login'">
                            <i class="fas fa-user"></i>
                        </b-nav-item>
                        <b-nav-item :href="appUrl + '/shopping-cart'">
                            <i class="fas fa-shopping-cart"></i>
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </header>  
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            //console.log(this.appUrl);
        },
    };
</script>
